// Shared project data used by the Projects grid and its expanded-view modal.

export const categories = ["All", "Full Stack", "AI / ML", "Data"];

export const projects = [
  {
    slug: "splitwise",
    title: "Splitwise",
    description:
      "A full-stack web application that allows users to split expenses and manage shared bills with friends",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1785482866/47216140-62e0-4a5b-8364-d75eab913078.png",
    previewLabel: "View on GitHub",
    category: "Full Stack",
    preview: "https://github.com/vicheda/splitwise",
  },
  {
    slug: "the-move",
    title: "The Move",
    description:
      "A live social discovery platform for Northwestern students to find and host spontaneous campus hangouts.",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1785992687/Screenshot_2026-08-06_at_12.03.57_AM_xu3ebq.png",
    previewLabel: "View on GitHub",
    category: ["Full Stack", "AI / ML"],
    preview: "https://github.com/vicheda/The-Move",
  },
  {
    slug: "newsfeed_app",
    title: "Newsfeed App",
    description:
      "A full-stack web application that allows users to view and post news articles, with authentication and authorization features",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1785483077/system_diagram_bllhjl.png",
    previewLabel: "View on GitHub",
    category: "Full Stack",
    preview: "https://github.com/vicheda/newsfeed_app",
  },
  {
    slug: "nettango",
    title: "NetTango",
    description:
      "Architected NetTango block-based coding interface for NetLogo code, by integrating Google Blockly framework to dynamically generate simulations model",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1750678794/Screenshot_2025-06-06_at_12.31.10_AM_rdyl5q.png",
    preview: "https://github.com/jwoolnt/ccl-nettango-blockly",
    previewLabel: "View on GitHub",
    category: "Full Stack",
  },
  {
    slug: "northwestern-ieee",
    title: "Northwestern IEEE",
    description:
      "A Chrome extension for Canvas to sync their syllabus with Google Calendar, recommend 4-year plan, and more.",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1746854081/2_dqspsc.png",
    preview: "https://github.com/vinayakkapoor05/CatCanvas",
    about: "https://canva.link/crd4a2cx8lz3qef",
    previewLabel: "View on GitHub",
    category: ["Full Stack", "AI / ML"],
  },
  {
    slug: "podcast-generator",
    title: "Podcast Generator",
    description:
      "A serverless app that generates podcast-style audio based on user queries like articles tag from the Guardian API",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1742660249/podcast_generator_onahok.png",
    preview: "https://github.com/vicheda/podcast_generator",
    previewLabel: "View on GitHub",
    category: "AI / ML",
  },
  {
    slug: "emoji-autoencoder",
    title: "Emoji Autoencoder",
    description:
      "Built an autoencoder to extract certain features from emojis using a HuggingFace dataset (by Valhalla)",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1764966925/autoencoders_e3tvla.png",
    preview: "https://github.com/vicheda/autoencoders",
    previewLabel: "View on GitHub",
    category: "AI / ML",
  },
  {
    slug: "jellyqueue",
    title: "JellyQueue",
    description:
      "A smart, AI-powered calendar scheduling web application built during WildHacks 2025.",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1746854081/1_auxgww.png",
    preview: "https://github.com/ysilksa/jellyqueue",
    previewLabel: "View on GitHub",
    category: "AI / ML",
  },
  {
    slug: "renewable-energy-forecaster",
    title: "Renewable Energy Forecaster",
    description:
      "Forecasting renewable energy generation using Python with solar radiation and wind speed data",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1742660249/renewable_energy_forcaster_lmtasl.png",
    preview: "https://github.com/vicheda/renewable_forcasters",
    previewLabel: "View on GitHub",
    category: "Data",
  },
  {
    slug: "connecther",
    title: "ConnectHer",
    description:
      "From TreeHacks, a platform that helps women connect, learn, and grow through mentorship, networking, and shared experiences.",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1742660248/connecther_lsxj0x.png",
    preview: "https://devpost.com/software/connecther-3bnhze",
    previewLabel: "View on Devpost",
    category: "Full Stack",
  },
  {
    slug: "rodov-website",
    title: "Rodov",
    description:
      "Menstrual Education Project Website built with HTML, CSS, & JavaScript",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1725035206/2_ptykkj.png",
    preview: "https://vicheda.github.io/rodov/",
    previewLabel: "View live site",
    category: "Full Stack",
  },
  {
    slug: "wander-in-tech-website",
    title: "Wander in Tech",
    description: "Technology Education Project Website built with React",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1725035206/1_cizsvw.png",
    preview: "https://zt3hsd.csb.app/",
    previewLabel: "View live site",
    category: "Full Stack",
  },
    {
    slug: "ieee-leadership",
    title: "NU IEEE",
    description:
      "Leading the Northwestern University IEEE student organization, manage project teams, and organize showcases with over 70 participants and 20 judges",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1785477265/IMG_8630_nqatk8.jpg",
    preview: "https://www.ieeenu.org/",
    previewLabel: "View website",
    category: "Leadership",
  },
  {
    slug: "rodov-leadership",
    title: "Rodov",
    description:
      "Founded Rodov to address social taboos around women's period by providing Menstrual Education to all women, especially young girls.",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1784257696/Rodov_rai54l.png",
    preview: "https://www.facebook.com/rodovtalk/",
    report: "https://drive.google.com/file/d/1YoD1nTsgQXO4lCaxcbI02tCjJxsxt6EI/view?usp=sharing",
    previewLabel: "View on Facebook",
    category: "Leadership",
  },
  {
    slug: "wander-in-tech-leadership",
    title: "Wander in Tech",
    description:
      "Founded Wander in Tech teaching web development and data science to 400+ underrepresented students",
    imgUrl:
      "https://res.cloudinary.com/ddtede37h/image/upload/v1725003666/7_gb0bde.png",
    preview: "https://www.facebook.com/wanderintech/",
    report: "https://canva.link/7hgiw5go9yeuhrf",
    previewLabel: "View on Facebook",
    category: "Leadership",
  },
];
